import { apiHttp } from "../axiosApi.js";
import { truck } from "../config/apiRoute.js";

export const getTTruckTypesAPI = (limit = 5, from = 0, all = false) => {
  return apiHttp("GET", `${truck}?limit=${limit}&from=${from}&all=${all}`);
};

export const getTruckTypeById = (id) => apiHttp("GET", `${truck}/${id}`);

export const patchTruckTypeById = (id, body) =>
  apiHttp("PATCH", `${truck}/${id}`, body);

export const patchTruckTypeStatus = (id, body) => {
  return apiHttp("PATCH", `${truck}/status/${id}`, body);
};

export const postTruckTypesAPI = (body) => apiHttp("POST", `${truck}`, body);

export const getTruckTypeAPI = () => apiHttp("GET", `${truck}`);
